export const BUYER_ENTRY_LINKS_TEMPLATE_PATH = '/templates/buyerEntryLinks.csv';
export const BUYER_ENTRY_LINKS_TEMPLATE_FILE_NAME = 'buyerEntryLinks.csv';
export const CLEAR_ENTRY_LINKS_CONFIRM_MESSAGE =
  'Are you sure you want to clear the uploaded unique links list?';
